import React from "react";

const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { height: 32 },
    default: { height: 44 },
    large: { height: 56 }
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        viewBox="0 0 280 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ height: currentSize.height, width: 'auto' }}
      >
        <defs>
          <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF8C00" />
            <stop offset="50%" stopColor="#FF6B00" />
            <stop offset="100%" stopColor="#FF4500" />
          </linearGradient>
          <linearGradient id="textGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FF9500" />
            <stop offset="100%" stopColor="#FF4500" />
          </linearGradient>
        </defs>
        
        {/* Icon - E in square */}
        <rect x="0" y="4" width="42" height="42" rx="6" fill="url(#logoGrad)" />
        <path d="M11 14H31V19H17V22H28V27H17V31H31V36H11V14Z" fill="white" />
        
        {/* EG text */}
        <text
          x="52"
          y="37"
          fill="url(#textGrad)"
          fontFamily="'Cabinet Grotesk', Arial, sans-serif"
          fontSize="34"
          fontWeight="900"
          letterSpacing="-1"
        >
          EG
        </text>
        
        {/* Solutions text */}
        <text
          x="98"
          y="37"
          fill="#FFFFFF"
          fontFamily="'Cabinet Grotesk', Arial, sans-serif"
          fontSize="30"
          fontWeight="400"
          letterSpacing="0"
        >
          Solutions
        </text>
      </svg>
    </div>
  );
};

export default Logo;
